import NTopNBottom from '../../components/NTopNBottom'

import bannerImg from '../../assets/retro/banner.jpg'
import navColor from '../../assets/retro/nav/color.jpg'
import navBg from '../../assets/retro/nav/nav_bg.png'
import navBgFixed from '../../assets/retro/nav/nav_bg_fixed.png'

import far1 from '../../assets/retro/nav/far1.png'
import far1_active from '../../assets/retro/nav/far1_active.png'
import far2 from '../../assets/retro/nav/far2.png'
import far2_active from '../../assets/retro/nav/far2_active.png'
import son1 from '../../assets/retro/nav/son1.png'
import son1_active from '../../assets/retro/nav/son1_active.png'
import son2 from '../../assets/retro/nav/son2.png'
import son2_active from '../../assets/retro/nav/son2_active.png'
import third1_1 from '../../assets/retro/nav/third1_1.png'
import third1_1_active from '../../assets/retro/nav/third1_1_active.png'
import third1_2 from '../../assets/retro/nav/third1_2.png'
import third1_2_active from '../../assets/retro/nav/third1_2_active.png'
import third1_3 from '../../assets/retro/nav/third1_3.png'
import third1_3_active from '../../assets/retro/nav/third1_3_active.png'
import third2_1 from '../../assets/retro/nav/third2_1.png'
import third2_1_active from '../../assets/retro/nav/third2_1_active.png'
import third2_2 from '../../assets/retro/nav/third2_2.png'
import third2_2_active from '../../assets/retro/nav/third2_2_active.png'
import third2_3 from '../../assets/retro/nav/third2_3.png'
import third2_3_active from '../../assets/retro/nav/third2_3_active.png'

import calcRemFn from '../calcRem'

const navCss = {
  navWrap: {
    paddingTop: 0,
    minHeight: calcRemFn(130),
    backgroundImage: `url(${navColor})`,
    boxSizing: 'border-box'
  },
  navCtn: {
    height: calcRemFn(130),
    backgroundImage: `url(${navBg})`,
  },
  navCtnFixed: {
    height: calcRemFn(130),
    backgroundImage: `url(${navBgFixed})`,
  },
  topBtnLayout: {
    alignItems: 'center',
    padding: `${calcRemFn(18)} ${calcRemFn(80)} 0 ${calcRemFn(80)}`,
  },
  topBtnBaseCss: {
    width: calcRemFn(96),
    height: calcRemFn(32),
    marginLeft: calcRemFn(5),
  },
  topBtnBaseCss2: {
    width: calcRemFn(72),
    height: calcRemFn(18),
    marginTop: calcRemFn(5),
    marginLeft: calcRemFn(0),
  },
  bottomBtnLayout: {
    padding: `${calcRemFn(6)} ${calcRemFn(85)} 0`,
  },
  bottomBtnBaseCss: {
    width: calcRemFn(32.5),
    height: calcRemFn(15.5),
  },
  thirdBtnLayout: {
    padding: `${calcRemFn(10)} ${calcRemFn(70)} 0`,
  },
  thirdBtnBaseCss: {
    height: calcRemFn(20),
  }
}

const navData = {
  retroSpec: true,
  component: NTopNBottom,
  top: [
    {
      key: 'top1',
      show: true,
      img: far1,
      img_actived: far1_active,
    },
    {
      key: 'top2',
      show: true,
      img: far2,
      img_actived: far2_active,
    }
  ],
  bottom: {
    top1: [
      {
        key: '_i1',
        show: true,
        img: son1,
        img_actived: son1_active
      },
      {
        key: '_i2',
        show: true,
        img: son2,
        img_actived: son2_active
      }
    ],
    top2: [
      {
        key: '_i1',
        show: true,
        img: son1,
        img_actived: son1_active
      },
      {
        key: '_i2',
        show: true,
        img: son2,
        img_actived: son2_active
      }
    ]
  },
  third: {
    top1_i1: [
      {
        key: '_t1',
        show: true,
        img: third1_1,
        img_actived: third1_1_active
      },
      {
        key: '_t2',
        show: true,
        img: third1_2,
        img_actived: third1_2_active
      },
      {
        key: '_t3',
        show: true,
        img: third1_3,
        img_actived: third1_3_active
      }
    ],
    top1_i2: [
      {
        key: '_t1',
        show: true,
        img: third1_1,
        img_actived: third1_1_active
      },
      {
        key: '_t2',
        show: true,
        img: third1_2,
        img_actived: third1_2_active
      },
      {
        key: '_t3',
        show: true,
        img: third1_3,
        img_actived: third1_3_active
      }
    ],
    top2_i1: [
      {
        key: '_t1',
        show: true,
        img: third2_1,
        img_actived: third2_1_active
      },
      {
        key: '_t2',
        show: true,
        img: third2_2,
        img_actived: third2_2_active
      },
      {
        key: '_t3',
        show: true,
        img: third2_3,
        img_actived: third2_3_active
      }
    ],
    top2_i2: [
      {
        key: '_t1',
        show: true,
        img: third2_1,
        img_actived: third2_1_active
      },
      {
        key: '_t2',
        show: true,
        img: third2_2,
        img_actived: third2_2_active
      },
      {
        key: '_t3',
        show: true,
        img: third2_3,
        img_actived: third2_3_active
      }
    ]
  }
}
const pictureList = [
  {
    key: '1_1_1',
    picNum: 3,
    pid: 94967
  },
  {
    key: '1_1_2',
    picNum: 4,
    pid: 94967
  },
  {
    key: '1_1_3',
    picNum: 3,
    pid: 94967
  },
  {
    key: '1_2_1',
    picNum: 2,
    pid: 94986
  },
  {
    key: '1_2_1',
    picNum: 2,
    pid: 95005,
    startIndex: 2,
    hideTitle: true
  },
  {
    key: '1_2_2',
    picNum: 2,
    pid: 94986
  },
  {
    key: '1_2_2',
    picNum: 2,
    pid: 95005,
    startIndex: 2,
    hideTitle: true
  },
  {
    key: '1_2_3',
    picNum: 2,
    pid: 94986
  },
  {
    key: '1_2_3',
    picNum: 1,
    pid: 95005,
    startIndex: 2,
    hideTitle: true
  },
  {
    key: '2_1_1',
    picNum: 3,
    pid: 94967
  },
  {
    key: '2_1_2',
    picNum: 4,
    pid: 94967
  },
  {
    key: '2_1_3',
    picNum: 3,
    pid: 94967
  },
  {
    key: '2_2_1',
    picNum: 3,
    pid: 95005
  },
  {
    key: '2_2_1',
    picNum: 1,
    pid: 94986,
    startIndex: 3,
    hideTitle: true
  },
  {
    key: '2_2_2',
    picNum: 2,
    pid: 94986
  },
  {
    key: '2_2_2',
    picNum: 2,
    pid: 95005,
    startIndex: 2,
    hideTitle: true
  },
  {
    key: '2_2_3',
    picNum: 2,
    pid: 95005
  },
  {
    key: '2_2_3',
    picNum: 2,
    pid: 94986,
    startIndex: 2,
    hideTitle: true
  }
]
const pictures = []
function requirePicture () {
  pictureList.forEach(item => {
    const { picNum, pid, key, startIndex = 0, hideTitle = false } = item
    const picList = []
    Array(picNum).fill(0).forEach((item, index) => {
      picList.push(require(`../../assets/retro/ctn/${key}_${index + startIndex + 1}.jpg`))
    })
    const indexArr = key.split('_')
    if (!hideTitle) {
      switch (key) {
      case '1_1_1':
        pictures.push({
          son: [
            require('../../assets/retro/ctn/tip.jpg'),
            require('../../assets/retro/ctn/1_1.jpg')
          ]
        })
        break
      case '1_2_1':
        pictures.push({
          son: [require('../../assets/retro/ctn/1_2.jpg')]
        })
        break
      case '2_1_1':
        pictures.push({
          son: [require('../../assets/retro/ctn/2_1.jpg')]
        })
        break
      case '2_2_1':
        pictures.push({
          son: [require('../../assets/retro/ctn/2_2.jpg')]
        })
        break
      }
    }

    pictures.push({
      id: pid,
      type: 'gold',
      ref: `top${indexArr[0]}_i${indexArr[1]}_t${indexArr[2]}`,
      farName: `top${indexArr[0]}`,
      sonName: `_i${indexArr[1]}`,
      thirdName: `_t${indexArr[2]}`,
      son: picList
    })
  })
}
requirePicture()
pictures.push({
  son: [require('../../assets/retro/ctn/authority.jpg')]
})

const topDiff = {
  firstSon: '_i1',
  firstThird: '_t1',
  // top1_i1: 10,
  // top1_i2: 20,
  // top2_i1: 5,
  // top2_i2: 16,
}

export default {
  title: 'HER-送你一场世纪之约',
  bannerImg,
  navCss,
  navData,
  pictures,
  topDiff,
  // allPic
}
